import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, Router} from '@angular/router';
import {FeatureTypeService} from '@catcore/services';
import * as utils from '@catcore/utils';
import {Observable} from 'rxjs/Rx';

@Injectable()
export class FeatureResolve implements Resolve<any> {
  constructor(protected service: FeatureTypeService,
              protected router: Router,
  ) {
  }

  /**
   * Loads the project-info based on a provided :projectId and returns a Observable
   */
  public resolve(route: ActivatedRouteSnapshot): Observable<any> | Promise<any> | any {
    const rootRoute = utils.resolveToRoot(route);
    const resourceId = utils.findValueFor('id', rootRoute);
    // return this.service.getOne(resourceId);
    this.service.loadAsCurrent(resourceId);
    return resourceId;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/features/services/feature.resolve.ts